<div class="m-0 hero">
  <div class="first container grid">
    <div class="row">
      <div class="col-12 text-center">
        <h1 class="desc-title neutral-00 mt-5" [innerHtml]="data.title"></h1>
        <div
          class="col-12 home-subtitle neutral-00 mt-3"
          [innerHtml]="data.subtitle"
        ></div>
        <img
          *ngIf="data.imgSrc !== ''"
          [src]="data.imgSrc"
          [ngClass]="data.class"
          alt="hero"
         
        />
      </div>
    </div>

      <div
        class="col-12 text-center"
      >
        <button class="btn-lightblue progetto-btn" (click)="redirectToApp()">
          <span class="button-txt">Prova Easycode</span>
        </button>
      </div>
  </div>
</div>
